import { getAllFlaggedQuestions, getCleanUpQuestions, getMultipleItemDetailsById, getQuestionsWithFilters } from 'gql/query'
import { IQuestionAnswerKey, findQuestionAnswers } from './questionAnswerKey'
import { resolveSubsectionLangs, sameLanguage } from './languageMode'


export const autoGenerateQuestions = async (paperDetails: any, userInfo: any) => {
  try {
    //checking is it internal or external user?
    const isInternalUser = userInfo.email.endsWith('@centa.org')
    const allFlaggedQuestionResponse: any = await getAllFlaggedQuestions()
    const cleanUpQuestionResponse: any = await getCleanUpQuestions()
    const flagedQuestionIds = await allFlaggedQuestionResponse.flagged_questions.map((question: { question_id: string }) => question.question_id)
    const cleanUpQuestionIds = await cleanUpQuestionResponse.cleanup_window_questions.map((question: { question_id: string }) => question.question_id)

    //extracting paper tempalate details
    const paperTemplateDetails = paperDetails.paper_template.paper_template
    const createdQuestionStatus = ['Published', 'Draft','Open','For Approval']
    const allSubSectionsWithQuestionIds = []
    const questionsAndAnswers: IQuestionAnswerKey[] = []

    //extracting grade Ids
    const gradeIds = paperDetails.test_track.grade_ids ? paperDetails.test_track.grade_ids : []

    //for storing already selected questions
    const assignedQuestions: string[] = []
    const assigned_question_integer_ids: string[] = []
    //storing variant question ids
    const variant_questions: number[] = []
    let questionCount = 0

    //looping each subsections
    for (const subsection of paperTemplateDetails) {
      console.log(subsection, 'subsection')
      const subsectionId = subsection.id ? subsection.id : ''
      const noOfQuestions = subsection.no_of_questions ? parseInt(subsection.no_of_questions) : 0
      const markPerQuestion = subsection.mark_per_question
      const subSectionQuestionType = subsection.question_type_id
      const topicId = subsection.topic_id ? subsection.topic_id : ''
      const subThemeId = subsection.sub_theme_id ? subsection.sub_theme_id : ''
      const themeId = subsection.theme_id ? subsection.theme_id : ''
      const reportThemeId = subsection.report_theme_id ? subsection.report_theme_id : ''
      const subjectId = subsection.subject_id ? subsection.subject_id : ''
      const subsectionWithQuestions: any = { id: subsectionId, questionIds: null }
      const bloomLevelId = subsection?.bloom_level?.id || ''
      const difficultyLevelId = subsection?.difficulty_level?.id || ''
      const competencyId = subsection?.competency_id || ''
      const strandId = subsection?.strand_id || ''
      const { base_lang, target_lang: transilaton_lang } = resolveSubsectionLangs(subsection, paperDetails)
      // If a subsection has both Base Language and Target Language, it is treated as a bilingual question set.
      // If a subsection has only a Base Language, it will include only the questions in that specified language.
      // If a subsection has only a Target Language, it will include the translated questions where the 'language' matches the specified Target Language and the 'translation_of' field is present.

      //fetching question details
      const getQuestionsResponse: any = await getQuestionsWithFilters({
        topicId,
        subThemeId,
        themeId,
        reportThemeId,
        subjectId,
        subSectionQuestionType,
        gradeIds,
        assignedQuestions,
        flagedQuestionIds,
        cleanUpQuestionIds,
        bloomLevelId,
        difficultyLevelId,
        competencyId,
        strandId,
        transilaton_lang,
        base_lang,
        variant_questions
      })

      //checking questions
      if (getQuestionsResponse.questions && getQuestionsResponse.questions.length > 0) {
        let allQuestions = getQuestionsResponse.questions
        if (base_lang && transilaton_lang) {
          //Get unique original question IDs from translations
          const getOriginalQuestionIds = Array.from(
            new Set(allQuestions.map((q: any) => q.transilation_of))
          );
          //fecting the question details
          const getOrginalQuestionDetails = await getMultipleItemDetailsById('questions', getOriginalQuestionIds, 'question_id', `id language question_id`, 'Int')
          //finding orginal questions with same base language
          if (getOrginalQuestionDetails.length > 0) {
            const baseLangOgQuestions = getOrginalQuestionDetails.reduce((acc: any[], q: any) => {
              if (sameLanguage(q.language, base_lang)) acc.push(q.question_id);
              return acc;
            }, []);
            //finding matching question details
            const matchedQuestions = allQuestions.filter((q: any) =>
              baseLangOgQuestions.includes(q.transilation_of)
            );
            allQuestions = matchedQuestions.length > 0 ? matchedQuestions : []
          } else {
            allQuestions = []
          }
        }
        //shuffling array
        const shuffledArray = await shuffleArray(allQuestions)
        const selectedQuestions: any = []

        for (const item of shuffledArray) {
          if (!flagedQuestionIds.includes(item.id)) {
            if (!cleanUpQuestionIds.includes(item.id)) {
              // checking is it internal user
              if (isInternalUser) {
                if (item.request_type === 'Q') {
                  if (createdQuestionStatus.includes(item.status)) {
                    if (selectedQuestions.length < noOfQuestions) {
                      if (item?.variant_of) {
                        //parent question already present
                        if (assigned_question_integer_ids?.includes(item.variant_of)) {
                          continue;
                        }
                        //storing the variant
                        variant_questions.push(item.variant_of)
                      }
                      selectedQuestions.push(item)
                      assignedQuestions.push(item.id)
                      assigned_question_integer_ids.push(item?.question_id)
                    } else {
                      break
                    }
                  }
                } else {
                  if (selectedQuestions.length < noOfQuestions) {
                    if (item?.variant_of) {
                        //parent question already present
                        if (assigned_question_integer_ids?.includes(item.variant_of)) {
                          continue;
                        }
                        //storing the variant
                        variant_questions.push(item.variant_of)
                      }
                    selectedQuestions.push(item)
                    assignedQuestions.push(item.id)
                    assigned_question_integer_ids.push(item?.question_id)
                  } else {
                    break
                  }
                }
              }
              //if it is external user
              else {
                if (item.status === 'Published') {
                  if (selectedQuestions.length < noOfQuestions) {
                    if (item?.variant_of) {
                        //parent question already present
                        if (assigned_question_integer_ids?.includes(item.variant_of)) {
                          continue;
                        }
                        //storing the variant
                        variant_questions.push(item.variant_of)
                      }
                    selectedQuestions.push(item)
                    assignedQuestions.push(item.id)
                    assigned_question_integer_ids.push(item?.question_id)
                  } else {
                    break
                  }
                }
              }
            }
          }
        }

        const findQuestionAnswersResponse: any = await findQuestionAnswers(selectedQuestions, markPerQuestion, subSectionQuestionType, questionCount)
        //changing the question count for changing question number
        questionCount = questionCount + selectedQuestions.length
        if (findQuestionAnswersResponse.status === true) {
          const selectedQuestionIds = findQuestionAnswersResponse.selectedQuestionId
          //pushing question answers
          questionsAndAnswers.push(...findQuestionAnswersResponse.questionAndAnswers)
          subsectionWithQuestions.questionIds = selectedQuestionIds
        }
      }
      allSubSectionsWithQuestionIds.push(subsectionWithQuestions)
    }
    if (allSubSectionsWithQuestionIds.length > 0 && questionsAndAnswers.length > 0) {
      console.log(allSubSectionsWithQuestionIds, questionsAndAnswers)
      return { allSubSectionsWithQuestionIds, questionsAndAnswers, status: true }
    }
    console.log(allSubSectionsWithQuestionIds, questionsAndAnswers)
    return { status: false }
  } catch (err) {
    console.log(err, 'error happend')
    return { status: false }
  }
}

//shuffling the array for avoiding duplication
const shuffleArray = async (array: any) => {
  const shuffledArray = await array.slice()
  await shuffledArray.sort(() => Math.random() - 0.5)
  return shuffledArray
}
